<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dostawcy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja dostawcy
            <p
              class="mt-2"
              style="font-weight: 100">{{data.name}}
              <d-badge
                style="font-size: 1rem"
                class="ml-2"
                :theme="data.active === 1 ? 'primary' : 'dark'">
                {{data.active === 1 ? 'Aktywny' : 'Nieaktywny'}}
              </d-badge>
            </p>
          </template>
          <template v-else>Dodawanie dostawcy</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/dostawcy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane ogólne"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer
              ref="suppliers-form"
              tag="form">
              <d-row>
                <d-col
                  cols="6"
                  md="6"
                  lg="8">
                  <div class="form-group">
                    <label for="name">
                      Imię i Nazwisko:
                    </label>
                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col
                  cols="6"
                  md="6"
                  lg="4">
                  <div class="form-group">
                    <validation-provider
                      rules="required"
                      name="active"
                      v-slot="{ errors }">
                      <label for="active">Aktywny:</label>
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="statusType"
                          :reduce="type => type.value"
                          v-model="data.active"
                          placeholder="Wybierz status aktywności"
                          label="text"
                          :state="errors.length ? 'invalid' : null">
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <div class="form-group">
                <label for="email">
                  E-mail:
                </label>

                <validation-provider
                  rules="required|email"
                  name="email"
                  v-slot="{ errors }">
                  <form autocomplete="off">
                    <d-input
                      :autocomplete="'off'"
                      :state="errors.length ? 'invalid' : null"
                      type="email"
                      v-model="data.email" />
                  </form>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="password">
                  Hasło:
                </label>

                <validation-provider
                  :rules="isEdit ? 'min:6' : 'required|min:6'"
                  name="password"
                  v-slot="{ errors }">
                  <form autocomplete="off">
                    <d-input
                      type="password"
                      :autocomplete="'off'"
                      :state="errors.length ? 'invalid' : null"
                      v-model="data.password" />
                  </form>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'suppliers-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedSuppliers;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    statusType () {
      return [
        {
          text: 'Tak',
          value: 1
        },
        {
          text: 'Nie',
          value: 0
        },
      ];
    }
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        active: ''
      },
      loaded: false,
      loadedSuppliers: false,
      load_error: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/suppliers/item/',
        instanceFields: ['name', 'email', 'password', 'active'],
        loadedKey: 'loaded'
      });
    },
    pushStatus (value) {
      this.data.active = value;
      this.validateForm();
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/suppliers/items',
        params: {
          pagination: false
        },
        outputKey: 'administrators',
        loadedKey: 'loadedSuppliers',
        errorKey: 'load_error',
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['suppliers-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/suppliers/update/' + this.id : '/suppliers/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano dostawcę',
        successText: 'Wybrany dostawca został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja dostawcy nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/dostawcy');
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name,
        email: this.data.email,
        active: this.data.active,
        password: this.data.password,
        type: 'SUPPLIER'
      };
      if (this.data.password !== '' && this.data.passwordConfirmation !== '') {
        formDataToSend.password = this.data.password;
        formDataToSend.password_confirmation = this.data.passwordConfirmation;
      }

      return formDataToSend;
    }
  }
};
</script>
<style lang="scss">
  .custom-select-style {
    .vs__actions {
      position: absolute;
      margin-left: 97%;
    }
  }
  .input-for-select {
    position: absolute;
    margin-top: -0.4rem;
    background: transparent;
    margin-left: -0.2rem;
    width: 100.6%;
  }
  .user-status-dropdown {
    margin-left: 2rem;
    border-radius: 20px;
    .dropdown-toggle {
      padding: 0.5rem 1.7rem;
    }
    .accept, .blocked {
      min-width: 8rem !important;
    }
  }
  @media only screen and (max-width: 1700px) {
    .custom-select-style {
      .vs__actions {
        position: absolute;
        margin-left: 95%;
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .custom-select-style {
      .vs__actions {
        position: absolute;
        margin-left: 92%;
      }
    }
  }
</style>
